var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT2T(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "Hourglass",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDBD05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38A04"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lift",
    x: "-8%",
    y: "-8%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 7,
    stdDeviation: 7,
    floodColor: "#8A4A00",
    floodOpacity: 0.24
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 207.2,
    fill: "url(#card)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glass",
    fill: "#fff",
    filter: "url(#lift)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 182.3V281.5C296 360.5 480 449 480 495.9C480 558.9 296 632.6 296 731.8V883.9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.3 182.3V281.5C725.3 360.5 541.3 449 541.3 495.9C541.3 558.9 725.3 632.6 725.3 731.8V883.9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 352.5L612 352.5Q577.3 387.4 512 418.2Q446.7 387.4 412 352.5Z",
    stroke: "#fff",
    strokeWidth: 10.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.7 764L462.7 694.3Q512 658.1 561.3 694.3L652 764Z",
    stroke: "#fff",
    strokeWidth: 10.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 156.8,
    width: 654.7,
    height: 40.2,
    rx: 20.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 793.5,
    width: 654.7,
    height: 40.2,
    rx: 20.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2T);
export default __webpack_public_path__ + "static/media/t2t.86ea59e10d6b0d64f5db55a84247425e.svg";
export { ForwardRef as ReactComponent };